import { Controller } from '@hotwired/stimulus';
import {ensureFormCsrfToken} from '../services/form.services';

export class LogoutController extends Controller {
    
    logout = (event?: Event) => {
        event?.preventDefault();

        // Create a form programmatically and submit it
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = '/logout';
        
        ensureFormCsrfToken(form);
        
        document.body.appendChild(form);
        form.requestSubmit();
    }
}
